import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=012d64c5&scoped=true&"
import script from "./TabsView.vue?vue&type=script&lang=js&"
export * from "./TabsView.vue?vue&type=script&lang=js&"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=012d64c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d64c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012d64c5')) {
      api.createRecord('012d64c5', component.options)
    } else {
      api.reload('012d64c5', component.options)
    }
    module.hot.accept("./TabsView.vue?vue&type=template&id=012d64c5&scoped=true&", function () {
      api.rerender('012d64c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/tabs/TabsView.vue"
export default component.exports